/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * agent_harness_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Harness names accepted by the model discovery endpoint.
 */
export type ModelHarnessDto =
  (typeof ModelHarnessDto)[keyof typeof ModelHarnessDto];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelHarnessDto = {
  'in-memory': 'in-memory',
  cursor: 'cursor',
  macrod: 'macrod',
} as const;
